export const getButtonOverrides = (theme, typography) => {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          ...typography.body.button,
          borderRadius: 20,
          height: 40,
          paddingLeft: 24,
          paddingRight: 24,
          backgroundColor: `${theme.palette.background.default} !important`,
          borderColor: theme.palette.primary.main,
          ".MuiButton-containedPrimary&:hover": {
            backgroundColor: theme.palette.primary.main,
            opacity: 0.92
          },
          ".MuiButton-containedPrimary&:active": {
            backgroundColor: theme.palette.primary.main,
            opacity: 0.88
          },
          ".MuiButton-outlinedPrimary&:hover": {
            backgroundColor: theme.palette.background.default,
            color: `${theme.palette.primary.main}92`,
            borderColor: `${theme.palette.primary.main}92`
          },
          ".MuiButton-outlinedPrimary&:active": {
            backgroundColor: theme.palette.background.default,
            color: `${theme.palette.primary.main}88`,
            borderColor: `${theme.palette.primary.main}88`
          },
          ".MuiButton-textPrimary&:hover": {
            backgroundColor: `${theme.palette.primary.main}08 !important`
          },
          ".MuiButton-textPrimary&:active": {
            backgroundColor: `${theme.palette.primary.main}12 !important`
          }
        },
        sizeMedium: {
          minWidth: "168px"
        }
      },
      variants: [{
        props: {
          variant: "contained"
        },
        style: {
          backgroundColor: `${theme.palette.primary.main} !important`,
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText
        }
      }, {
        props: {
          variant: "outlined"
        },
        style: {
          backgroundColor: "transparent !important",
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main
        }
      }, {
        props: {
          variant: "text"
        },
        style: {
          backgroundColor: "transparent !important",
          borderColor: theme.palette.background.paper,
          color: theme.palette.primary.main
        }
      }, {
        props: {
          variant: "outlined",
          disabled: true
        },
        style: {
          color: `${theme.palette.primary.main}38 !important`,
          border: `1px solid ${theme.palette.primary.main}38 !important`
        }
      }, {
        props: {
          variant: "text",
          disabled: true
        },
        style: {
          color: `${theme.palette.primary.main}38 !important`
        }
      }, {
        props: {
          variant: "contained",
          disabled: true
        },
        style: {
          backgroundColor: `${theme.palette.primary.main}38 !important`,
          color: `${theme.palette.primary.contrastText} !important`
        }
      }]
    }
  };
};